import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleUserInProjects = {
  namespaced: true,

  state: {
    name: 'userInProjects',
    userProjects: [],
  },

  mutations,
  getters,
  actions
}

export default moduleUserInProjects;